// src/components/ThirdPartyContact/Components/ThirdPartyContactActionCell.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useTheme } from "@mui/material/styles";

const ThirdPartyContactActionCell = ({ id, row, onEditContact }) => {
  const apiRef = useGridApiContext();
  const theme = useTheme();


  const handleEdit = () => {
    onEditContact(row);
  };

  return (
    <Tooltip title="Edit Contact">
      <IconButton onClick={handleEdit} size="small" sx={{ color: theme.palette.text.primary }}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ThirdPartyContactActionCell;
